

















































import Vue from 'vue'

export default Vue.extend({
  props: {
    openingMenuName: {
      type: String,
      default: '',
    },
    navigations: {
      type: Array,
      default: () => [],
    },
    flat: {
      type: Boolean,
      default: false,
    },
    autoHeight: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickMenu(name): void {
      this.$emit('update:opening-menu-name', this.openingMenuName === name ? '' : name)
    },
  },
})
